import * as tslib_1 from "tslib";
import { Trace } from "../logging/Trace";
var BaseComponent = /** @class */ (function () {
    function BaseComponent(options) {
        this.destroyed = false;
        this.extendOptions(options);
    }
    BaseComponent.prototype.build = function (childNodes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hostElement;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.render(childNodes)];
                    case 1:
                        hostElement = _a.sent();
                        this.id = BaseComponent.lastComponentId++;
                        this.hostElement = $(hostElement);
                        this.hostElement
                            .attr('data-xmid', this.id)
                            .data('component', this);
                        return [2 /*return*/, hostElement];
                }
            });
        });
    };
    BaseComponent.prototype.destroy = function () {
        if (this.destroyed)
            return;
        this.getChildComponents()
            .forEach(function (component) { return component.destroy(); });
        this.getHostElement()
            .removeAttr('data-xmid')
            .data('component', null);
        this.destroyed = true;
    };
    BaseComponent.prototype.fireEvent = function (eventName) {
        var eventArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            eventArgs[_i - 1] = arguments[_i];
        }
        if (!this.getEventTarget())
            return;
        this.getEventTarget().trigger(eventName, [this].concat(eventArgs));
    };
    BaseComponent.prototype.fireHandler = function (eventName) {
        var eventArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            eventArgs[_i - 1] = arguments[_i];
        }
        if (!this.getHostElement())
            return;
        this.getHostElement().triggerHandler(eventName, [this].concat(eventArgs));
    };
    BaseComponent.prototype.broadcastEvent = function (eventName, selector) {
        var eventArgs = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            eventArgs[_i - 2] = arguments[_i];
        }
        if (!this.getHostElement())
            return;
        this.getHostElement().find(selector).trigger(eventName, [this].concat(eventArgs));
    };
    BaseComponent.prototype.getComponentId = function () {
        return this.id;
    };
    BaseComponent.prototype.getHostElement = function () {
        return this.hostElement;
    };
    BaseComponent.prototype.getHostElementSize = function () {
        var hostContainer = this.hostElement.parent();
        var className = hostContainer.attr('class');
        var dummyContainer = $('<div style="visibility: hidden;"></div>').addClass(className).insertAfter(hostContainer);
        var dummyElement = this.hostElement.clone().detach();
        this.prepareHostElementForSizeCalculation(dummyElement, dummyContainer);
        dummyElement.appendTo(dummyContainer);
        var result = this.calculateHostElementSize(dummyElement);
        dummyContainer.remove();
        return result;
    };
    BaseComponent.prototype.prepareHostElementForSizeCalculation = function (dummyElement, dummyContainer) {
        dummyElement.css({
            position: 'static',
            display: ''
        });
    };
    BaseComponent.prototype.calculateHostElementSize = function (dummyElement) {
        return {
            width: dummyElement.outerWidth(),
            height: dummyElement.outerHeight()
        };
    };
    BaseComponent.prototype.onMount = function () {
    };
    BaseComponent.prototype.getChildComponents = function () {
        return this.getHostElement()
            .find('[data-xmid]')
            .toArray()
            .map(function (elem) { return $(elem).data('component'); })
            .filter(function (component) { return component != null; });
    };
    BaseComponent.prototype.extendOptions = function (extendedOptions) {
        this.options = $.extend(true, this.getDefaultOptions(), extendedOptions);
    };
    BaseComponent.prototype.getEventTarget = function () {
        return this.getHostElement();
    };
    BaseComponent.prototype.getDefaultOptions = function () {
        return {};
    };
    BaseComponent.prototype.cls = function () {
        var classes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            classes[_i] = arguments[_i];
        }
        return classes.filter(function (cls) { return cls; }).join(' ');
    };
    BaseComponent.lastComponentId = 0;
    tslib_1.__decorate([
        Trace()
    ], BaseComponent.prototype, "fireEvent", null);
    tslib_1.__decorate([
        Trace()
    ], BaseComponent.prototype, "fireHandler", null);
    tslib_1.__decorate([
        Trace()
    ], BaseComponent.prototype, "broadcastEvent", null);
    tslib_1.__decorate([
        Trace()
    ], BaseComponent.prototype, "extendOptions", null);
    return BaseComponent;
}());
export { BaseComponent };
//# sourceMappingURL=BaseComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/components/BaseComponent.js
// module id = 2
// module chunks = 1